import * as _ from 'underscore';
import * as $ from 'jquery';

import BaseStore from '../../../../_common/platform/ts/BaseStore';
import { apiCall } from '../../../../_common/platform/ts/AqlUtility';
import { Constants } from '../../../../_common/platform/ts/Constants';
import * as Utilities from '../../../../_common/platform/ts/Utilities';

import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';
import { Action, AppActions, I, check as checkAction } from '../actions/AppActions';

import { IGlob } from './../Glob';

export interface ITemplatesDirsState {
    data: ITemplatesDirsData;
}

export interface ITemplatesDirsData {
    [index: string]: ITemplatesDirsInstanceState;
}

export interface ITemplatesDirsInstanceState {
    loading: boolean;
    renameLoading: any;

    errors: any;

    dirId: any;
    dirContent: {
        wtid;
        name: string;
        data;
    }[];

    rename: any;

    _defs: any;
}

export class TemplatesDirsStore extends BaseStore<ITemplatesDirsState, AppActions, Dispatcher, IGlob> {
    public _state: ITemplatesDirsState;
    public static _name = 'templates-dirs';

    public static getInitialState() {
        const data: ITemplatesDirsData = {};

        return {
            data: data
        };
    }

    private static getInitialInstanceState(id) {
        return {
            loading: false,
            renameLoading: {},

            errors: [],

            dirId: null,
            dirContent: null,

            rename: null,

            _defs: {
                contentSingle: null
            }
        };
    }

    public getInstanceState(id) {
        let state = this._state.data[id];

        if (state == null) {
            state = this._state.data[id] = TemplatesDirsStore.getInitialInstanceState(id);
        }

        return state;
    }

    private requestTemplateData(id) {
        return apiCall<any>(this.actions, 'widgetTemplate_GetData', {
            wtid: id
        });
    }

    public getDirContent(id) {
        return apiCall<any[]>(this.actions, 'widgetTemplate_GetDirContent', {
            dirid: id
        });
    }

    private getDataForTemplateObj(obj) {
        const def = this.requestTemplateData(obj.wtid).then((resp) => {
            try {
                obj.data = JSON.parse(resp.result);
            } catch (e) {
                obj.data = null;
            }
        });

        return def;
    }

    public singleLoad(id, instanceId) {
        let instanceState = this._state.data[instanceId];

        if (instanceState == null) {
            instanceState = this._state.data[instanceId] = TemplatesDirsStore.getInitialInstanceState(instanceId);
        }

        instanceState.dirId = id;

        if (instanceState._defs.content != null && instanceState._defs.content.state() === 'pending') {
            instanceState._defs.content.reject(null, true);
        }

        instanceState.loading = true;

        const def = this.getDirContent(id);

        instanceState._defs.content = def;

        def.then((resp) => {
            instanceState.dirContent = Utilities.sortByName(resp.result);

            const defAll = $.when.apply(
                $,

                _.map<any, any>(
                    resp.result,

                    (obj) => {
                        return this.getDataForTemplateObj(obj);
                    }
                )
            );

            const def_2 = $.Deferred<any>();

            defAll.done(function (resp) {
                def_2.resolve(resp);
            });

            defAll.fail(function (resp) {
                def_2.reject(resp);
            });

            return def_2;
        })
            .then(() => {
                this.actions.templatesExplorerSingleLoadFinish(id, instanceId);
            })
            .fail((_resp, cancel) => {
                if (cancel === true) {
                    return;
                }

                instanceState.dirContent = [];

                this.actions.showNotification_Fail("Fail to load content of folder '" + id + "'");
            });

        return def;
    }

    private singleLoadFinish(id, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        instanceState.loading = false;
    }

    private clearState(instanceId) {
        if (this._state.data[instanceId] == null) {
            return;
        }

        this._state.data[instanceId] = TemplatesDirsStore.getInitialInstanceState(instanceId);
    }

    private renameStart(id, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        instanceState.rename = id;
    }

    private renameEnd(id, value, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        instanceState.rename = null;

        const obj = _.find(instanceState.dirContent, (obj) => {
            return obj.wtid === id;
        });

        if (obj == null) {
            return;
        }

        const prevName = obj.name;

        obj.name = value;

        instanceState.renameLoading[obj.wtid] = true;

        apiCall(
            this.actions,
            'widgetTemplate_Rename',
            {
                name: value,
                wtid: obj.wtid
            },
            null
        )
            .done((_resp) => {
                this.actions.showNotification_Success(
                    'Widget "' + id + '" was successfully renamed to "' + value + '"'
                );
            })
            .fail((_obj) => {
                obj.name = prevName;
            })
            .always(() => {
                this.actions.templateRenameFinish(obj.wtid, instanceId);
            });
    }

    private renameFinish(id, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        delete instanceState.renameLoading[id];
    }

    private renameFromEdit(id, value) {
        let arr = _.map(
            this._state.data,

            (inst, instId) => {
                return _.find(inst.dirContent, (obj) => {
                    return obj.wtid === id;
                });
            }
        );

        arr = _.compact(arr);

        _.each(arr, (obj) => {
            obj.name = value;
        });
    }

    private templateDelete(id, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        const obj = _.find(instanceState.dirContent, (obj) => {
            return obj.wtid === id;
        });

        if (obj == null) {
            return;
        }

        instanceState.renameLoading[id] = true;
    }

    private templateDeleteFinish(success, id, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        delete instanceState.renameLoading[id];

        if (success !== true) {
            return;
        }

        const obj = _.find(instanceState.dirContent, (obj) => {
            return obj.wtid === id;
        });

        if (obj == null) {
            return;
        }

        instanceState.dirContent.splice(_.indexOf(instanceState.dirContent, obj), 1);
    }

    private templateMove(id, overwrite, currentDirId, dirId, instanceId) {
        if (currentDirId === dirId) {
            return;
        }

        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        const obj = _.find(instanceState.dirContent, (obj) => {
            return obj.wtid === id;
        });

        if (obj == null) {
            return;
        }

        instanceState.renameLoading[id] = true;

        apiCall(this.actions, 'widgetTemplate_Move', {
            wtid: id,
            overwrite: overwrite,
            newdirid: dirId
        })
            .done(() => {
                this.actions.templateMoveFinish(true, id, currentDirId, dirId, instanceId);

                this.actions.showNotification_Success(
                    'Widget "' + id + '" was successfully moved to the folder "' + dirId + '"'
                );
            })
            .fail((obj) => {
                this.actions.templateMoveFinish(false, id, currentDirId, dirId, instanceId);
            });
    }

    private templateMoveFinish(success, id, currentDirId, dirId, instanceId) {
        const instanceState = this._state.data[instanceId];
        if (instanceState == null) {
            return;
        }

        delete instanceState.renameLoading[id];

        if (success !== true) {
            return;
        }

        const obj = _.find(instanceState.dirContent, (obj) => {
            return obj.wtid === id;
        });

        if (obj == null) {
            return;
        }

        instanceState.dirContent.splice(_.indexOf(instanceState.dirContent, obj), 1);
    }

    private templateSaveFinish(id, dirId, name, data) {
        if (id == null) {
            return;
        }

        let arr = _.map(this._state.data, (inst) => {
            return _.find(inst.dirContent, (obj) => {
                return obj.wtid === id;
            });
        });

        arr = _.compact(arr);

        _.each(arr, (obj) => {
            if (name != null) {
                obj.name = name;
            }

            if (data != null) {
                obj.data = JSON.parse(data);
            }
        });

        if (arr.length === 0 && dirId != null) {
            const instances = _.filter(this._state.data, (inst) => {
                return inst.dirId === dirId;
            });

            _.each(instances, (inst) => {
                inst.dirContent.push({
                    wtid: id,
                    name: name,
                    data: JSON.parse(data)
                });
            });
        }
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const a: Action = payload.action;
        const _case = checkAction;

        do {
            if (_case<I.TEMPLATES_EXPLORER_CLEAR>(a, Constants.TEMPLATES_EXPLORER_CLEAR)) {
                this.clearState(a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATES_EXPLORER_SINGLE_LOAD>(a, Constants.TEMPLATES_EXPLORER_SINGLE_LOAD)) {
                this.singleLoad(a.id, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATES_EXPLORER_SINGLE_LOAD_FINISH>(a, Constants.TEMPLATES_EXPLORER_SINGLE_LOAD_FINISH)) {
                this.singleLoadFinish(a.id, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_SAVE_FINISH>(a, Constants.TEMPLATE_SAVE_FINISH)) {
                this.templateSaveFinish(a.id, a.dirId, a.name, a.data);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_RENAME_START>(a, Constants.TEMPLATE_RENAME_START)) {
                this.renameStart(a.id, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_RENAME_END>(a, Constants.TEMPLATE_RENAME_END)) {
                this.renameEnd(a.id, a.value, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_RENAME>(a, Constants.TEMPLATE_RENAME)) {
                this.renameFromEdit(a.id, a.value);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_RENAME_FINISH>(a, Constants.TEMPLATE_RENAME_FINISH)) {
                this.renameFinish(a.id, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_DELETE>(a, Constants.TEMPLATE_DELETE)) {
                this.templateDelete(a.id, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_DELETE_FINISH>(a, Constants.TEMPLATE_DELETE_FINISH)) {
                this.templateDeleteFinish(a.success, a.id, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_MOVE>(a, Constants.TEMPLATE_MOVE)) {
                this.templateMove(a.id, a.overwrite, a.currentDirId, a.dirId, a.instanceId);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_MOVE_FINISH>(a, Constants.TEMPLATE_MOVE_FINISH)) {
                this.templateMoveFinish(a.success, a.id, a.currentDirId, a.dirId, a.instanceId);
                this.emitChange();
                break;
            }
        } while (false);

        return true;
    }

    constructor(glob, dispatcher: Dispatcher, actions: AppActions) {
        super(glob, dispatcher, actions, TemplatesDirsStore._name);

        this._state = _.extend(TemplatesDirsStore.getInitialState(), this._state);
    }

    static get(glob, dispatcher: Dispatcher, actions: AppActions) {
        return new TemplatesDirsStore(glob, dispatcher, actions);
    }
}
